import { useSearchParams } from "react-router";
import { MoneyTransferInfoDTO } from "./MoneyTransferInfoDTO.ts";
import { decode, encode } from "js-base64";
import { useCallback } from "react";

export function useMoneyTransferInfoQueryStringRepository() {
  const paramKey = "info";
  const [searchParams] = useSearchParams();
  const infoString = searchParams.get(paramKey) ?? undefined;
  const decorateUrlWithEncodedMoneyTransferInfo = useCallback(
    (info: MoneyTransferInfoDTO, url: URL) => {
      const encodedInfo = encode(JSON.stringify(info));
      url.searchParams.set(paramKey, encodedInfo);
      return url;
    },
    [],
  );
  if (!infoString)
    return {
      info: undefined,
      decorateUrlWithEncodedMoneyTransferInfo,
    };
  const info: MoneyTransferInfoDTO = JSON.parse(decode(infoString));

  return {
    info,
    decorateUrlWithEncodedMoneyTransferInfo,
  };
}
